'use client';

import { useInfiniteQuery } from '@tanstack/react-query';
import { getContentSections } from '@/APIs/contentApi';
import useResume from '@/services/useResume';
import { useEffect, useState } from 'react';

export default function useContent({ isBabiesMode = false, pageId = '' } = {}) {
    const [enableGetVideoLogData, setEnableGetVideoLogData] = useState(false);
    const [enableGetAudioLogData, setEnableGetAudioLogData] = useState(false);
    const { videoResumeListCardsData, audioResumeListCardsData } = useResume({
        enableGetVideoLogData,
        enableGetAudioLogData
    });

    const { error, data, isFetchingNextPage, fetchNextPage } = useInfiniteQuery({
        queryKey: ['getContent', isBabiesMode],
        queryFn: async (input) => {
            const resp = await getContentSections({
                links: input?.pageParam,
                isBabiesMode,
                id: pageId
            });
            resp?.results?.sections?.forEach((section) => {
                if (section?.contents_generator === 'Stream Log') {
                    switch (section?.content_type) {
                        case 'Video': {
                            setEnableGetVideoLogData(true);
                            break;
                        }
                        case 'Audio': {
                            setEnableGetAudioLogData(true);
                            break;
                        }
                    }
                }
            });

            return resp;
        },
        getNextPageParam: (lastPage) => {
            if (lastPage?.links?.next) {
                return lastPage?.links;
            } else {
                return undefined;
            }
        },
        staleTime: 30 * 60 * 1000,
        retry: (retryCount, error) => {
            return !error?.response?.status === 404;
        }
    });

    useEffect(() => {
        /* if there was a resume section in the latest received result, fetch related logData from logCollector (enable its query) */
        if (data) {
            data?.pages.forEach((page) => {
                page?.results?.sections?.forEach((section) => {
                    if (section?.contents_generator === 'Stream Log') {
                        switch (section?.content_type) {
                            case 'Video': {
                                setEnableGetVideoLogData(true);
                                break;
                            }
                            case 'Audio': {
                                setEnableGetAudioLogData(true);
                                break;
                            }
                        }
                    }
                });
            });
        }
    }, []);

    return {
        error,
        data,
        isFetchingNextPage,
        fetchNextPage,
        videoResumeListCardsData,
        audioResumeListCardsData
    };
}
